import * as tslib_1 from "tslib";
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import shouldSkipProcessRow from './helpers/shouldSkipProcessRow';
import TableOperations from 'owa-mail-list-table-operations';
import updateInstrumentationContext from 'owa-mail-list-store/lib/utils/updateInstrumentationContext';
import { action } from 'satcheljs/lib/legacy';
import { attachmentPreviewOperations } from 'owa-mail-attachment-previews';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { getRowKeyFromListViewType } from 'owa-mail-list-store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { lazyFetchCouponData } from 'owa-mail-coupon-peek';
export default action('appendRowResponse')(
/**
 * Process FindConversation/FindItem response and append them to the end of the given TableView
 * @param tableView to append results in
 * @param rows to be appended
 * @param totalRowsInViewInResponse - total rows in the table returned from server
 * @param searchResponseId - the search query id
 */
function appendRowResponse(tableView, rows, totalRowsInViewInResponse, searchResponseId) {
    var e_1, _a;
    var rowList = rows || [];
    try {
        for (var rowList_1 = tslib_1.__values(rowList), rowList_1_1 = rowList_1.next(); !rowList_1_1.done; rowList_1_1 = rowList_1.next()) {
            var row = rowList_1_1.value;
            // Check if row should be skipped
            if (shouldSkipProcessRow(row, tableView)) {
                continue;
            }
            // Append all rows to end of table
            if (TableOperations.containsRowKey(tableView, getRowKeyFromListViewType(row, tableView.tableQuery.listViewType))) {
                // Move row to new position in table if it already exists. There could be some timing issue
                // where the row was moved down on the server. In this case we want to keep the server's latest order
                TableOperations.updateRow(tableView.rowKeys.length - 1, row, tableView);
            }
            else {
                TableOperations.appendRow(row, tableView);
            }
            if (searchResponseId) {
                var instrumentationContext = {
                    referenceKey: row.ReferenceKey,
                    index: tableView.rowKeys.length - 1,
                    traceId: searchResponseId,
                };
                updateInstrumentationContext(row.InstanceKey, tableView, instrumentationContext);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rowList_1_1 && !rowList_1_1.done && (_a = rowList_1.return)) _a.call(rowList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // VSO 1285: optimize this number on empty folder
    tableView.totalRowsInView = totalRowsInViewInResponse; // Sketch: does this belong here?
    if (getUserConfiguration().UserOptions.ShowInlinePreviews) {
        // Get the attachment previews
        attachmentPreviewOperations.getPreviews(getMailboxInfo(tableView), tableView.tableQuery.listViewType);
    }
    if (isControlFeatureEnabled('tri-coupon-peek')) {
        lazyFetchCouponData.import().then(function (fetchCouponData) {
            fetchCouponData(getMailboxInfo(tableView).mailboxId, tableView.tableQuery.listViewType);
        });
    }
});
//# sourceMappingURL=appendRowResponse.js.map